//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/Builder.js";
import "../GeometricUtilities/GeometricUtilities.ReduceSurfaceRadiusFaceGroupBuilderList.js";
import "../GeometricUtilities/GeometricUtilities.OnPathDimensionBuilder.js";
import "../no/ScCollector.js";
import "../no/ScCollector.js";
import "../no/ObjectList.js";
let d=[[[0,"Direction",1,0],[1,"FaceGroupList",0,"GeometricUtilities.ReduceSurfaceRadiusFaceGroupBuilderList",0],[0,"HighRadius",1,0],[0,"IndexListItem",1,0],[0,"LowRadius",1,0],[1,"OnPathDimEnd",0,"GeometricUtilities.OnPathDimensionBuilder",0],[1,"OnPathDimStart",0,"GeometricUtilities.OnPathDimensionBuilder",0],[0,"PercentReduction",1,0],[0,"PositionTolerance",1,0],[0,"ReduceValueType",1,0],[0,"ReducedFaceType",1,0],[1,"SelectChain",0,"ScCollector",0],[1,"SelectFace",0,"ScCollector",0],[0,"TangentTolerance",1,0],[0,"TargetReduction",1,0],[0,"ValueReduction",1,0]],[],[]];
SPLM.GeometricUtilities.ReduceSurfaceRadiusBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.ReduceSurfaceRadiusBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.ReduceSurfaceRadiusBuilder.FaceSelectionSpecification = Object.freeze({
    "Radius" : "Radius", "Chain" : "Chain", "Select" : "Select"});

SPLM.GeometricUtilities.ReduceSurfaceRadiusBuilder.ReduceValueTypeSpecification = Object.freeze({
    "Percentage" : "Percentage", "Value" : "Value", "Delta" : "Delta"});

SPLM.GeometricUtilities.ReduceSurfaceRadiusBuilder.ReducedFaceTypeSpecification = Object.freeze({
    "FaceGroup" : "FaceGroup", "SingleChainInGroup" : "SingleChainInGroup", "SingleChain" : "SingleChain"});

export default SPLM;